<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >First Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
              required: true,
              regex:
              '^[A-Za-z][A-Za-z ]*$'
            }">
              <input
                  id="firstName"
                  v-model="formValues.firstName"
                  class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >Father Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
              required: true,
              regex:
              '^[A-Za-z][A-Za-z ]*$'
            }">
              <input
                  id="fatherName"
                  v-model="formValues.fatherName"
                  class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >Grand Father Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
              required: true,
              regex:
              '^[A-Za-z][A-Za-z ]*$'
            }">
              <input
                  id="grandFatherName"
                  v-model="formValues.grandFatherName"
                  class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Sex</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="Male"
                  v-model="formValues.sex"
                  class="my-3 ml-5"
                  type="radio"
                  value="Male"
              />
              <label for="Male"> Male </label>

              <input
                  id="Female"
                  v-model="formValues.sex"
                  class="my-3 ml-5"
                  type="radio"
                  value="Female"
              />
              <label for="Female"> Female </label>
              <br/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >ID No.</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="idNo"
                  v-model="formValues.idNo"
                  class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >Background Profession</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="backgroundProfession"
                  v-model="formValues.backgroundProfession"
                  class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >Education Program</label
            >
            <validation-provider v-slot="{ errors }" rules="required">

              <v-select
                  v-model="formValues.educationProgramId"
                  :elevation="1"
                  :items="EDUCATIONAL_PROGRAMS"
                  :loading="lookupLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >Department</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="department"
                  v-model="formValues.department"
                  class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >Level Of Education</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.levelOfStudyId"
                  :elevation="1"
                  :items="LEVEL_OF_STUDIES"
                  :loading="lookupLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >Entry Year</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                post_graduate_regex: '^[0-9]{4}$',
                min_graduate_value: 1950,
              }"
            >
              <input
                  id="entryYear"
                  v-model="formValues.entryYear"
                  class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    "
                  name
                  type="number"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
                "
            >Expected Year Of Graduation</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                post_graduate_regex: '^[0-9]{4}$',
                min_expected_value: +formValues.entryYear + 2,
              }"
            >
              <input
                  id="expectedYearOfGraduation"
                  v-model="formValues.expectedYear"
                  :disabled="!formValues.entryYear"
                  class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    "
                  name
                  type="number"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
                class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
            >Year Of Graduation</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                  generic_regex: '^[0-9]{4}$',
                  min_proposed_value: +formValues.entryYear + 2,
                }"
            >
              <input
                  id="yearOfGraduation"
                  v-model="formValues.graduationYear"
                  :disabled="!formValues.expectedYear"
                  class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                  name
                  type="number"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Is Withdrawn?</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="Yes"
                  v-model="formValues.isWithdrawn"
                  class="my-3 ml-5"
                  type="radio"
                  value="Yes"
              />
              <label for="Yes"> Yes </label>

              <input
                  id="No"
                  v-model="formValues.isWithdrawn"
                  class="my-3 ml-5"
                  type="radio"
                  value="No"
              />
              <label for="No"> No </label>
              <br/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
            >Nationality</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
                          }">
              <input
                  id="firstName"
                  v-model="formValues.nationality"
                  class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="w-full">
              <button
                  class="float-right shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="button"
                  @click="submit()"
              >
                {{ formValues.editMode ? "Update" : "Save" }}
              </button>
            </div>
            <div class="md:w-2/3"></div>
          </div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {min_value, regex, required} from "vee-validate/dist/rules";
import {getEducationalPrograms, getLevelOfStudies} from "@/utils/helper";
import ethiopic from "ethiopic-calendar";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("post_graduate_regex", {
  ...regex,
  message: "Invalid year value. Year must have 4 digits",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letter"
})
extend("min_graduate_value", {
  ...min_value,
  message: "Minimum year value must be greater than 1950",
});
extend("min_expected_value", {
  ...min_value,
  message:
      "Minimum expected year of graduation must not be less than entry year + 2",
});

export default {
  props: {
    graduates: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        firstName: null,
        fatherName: null,
        grandFatherName: null,
        sex: null,
        idNo: null,
        backgroundProfession: null,
        educationProgramId: null,
        department: null,
        levelOfStudyId: null,
        entryYear: null,
        expectedYear: null,
        graduationYear: null,
        isWithdrawn: "No",
        preServiceLevel: 'NimeiProgram',
        nationality: 'Ethiopia',
        editMode: false,
      },

      lookupLoading: false,
      currentYear: new Date().getFullYear(),
      etCurrentYear: null,
      LEVEL_OF_STUDIES: [],
      EDUCATIONAL_PROGRAMS: [],
    };
  },
  async created() {
    await this.initateLookups();
    this.etCurrentYear = this.convertYearGE(this.currentYear);
    if (this.graduates != null) {
      this.formValues = this.graduates;
      this.formValues.editMode = true;
    }
  },
  methods: {
    async initateLookups() {
      this.lookupLoading = true;
      this.LEVEL_OF_STUDIES = await getLevelOfStudies();
      console.log(this.LEVEL_OF_STUDIES.rows)
      this.LEVEL_OF_STUDIES = this.LEVEL_OF_STUDIES?.rows?.filter(x => x.level_type == 'NIMEI Program');
      console.log(this.LEVEL_OF_STUDIES)
      this.EDUCATIONAL_PROGRAMS = await getEducationalPrograms();
      this.EDUCATIONAL_PROGRAMS = this.EDUCATIONAL_PROGRAMS.rows
      this.lookupLoading = false;
    },
    convertYearGE(val) {
      if (!val) return val;
      const year = val;
      const month = null;
      const day = null;
      let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
      return etDate.year.toString().padStart(4, "0");
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateNimeiPrograms", this.formValues);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>